import { ReactComponent as TemplateIcon } from "assets/svg/specialReq.svg";
import { SurveyTemplate } from "../../types";
import { getContestDefaults } from "../helpers";

export const specialRequest: SurveyTemplate = {
  icon: <TemplateIcon />,
  title: "Special Request",
  description: "Ask fans to register to make a special request for the live.",
  templateId: "specialRequest",
  template: (v, formState) => ({
    fields: {
      description: {
        content: {
          en: "Special Request",
        },
      },
      ...getContestDefaults(formState),
    },
    ...(formState.hasSweeps === "Yes" && {
      flags: {
        showContestConfirmationMessage: true,
      },
    }),
  }),
  prompt: {
    promptId: (state) =>
      state.hasSweeps === "Yes"
        ? "pp-livestream-396db4"
        : "pp-livestream-73b4fa",
    fields: [
      {
        name: "date",
        type: "text",
        label: "When does your livestream take place?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.date ? false : "This field cannot be left blank",
      },
      {
        name: "hasSweeps",
        type: "radio",
        label: "Will you be offering a sweepstakes prize?",
        options: ["Yes", "No"],
        getValidation: (fields) =>
          !!fields.hasSweeps ? false : "You must select an option.",
      },
      {
        name: "prize",
        type: "text",
        label: "What's the prize?",
        placeholder: "Enter your answer...",
        getValidation: (fields) =>
          fields.prize || fields.hasSweeps === "No"
            ? false
            : "This field cannot be left blank",
        isVisible: (form) => form.hasSweeps === "Yes",
      },
    ],
  },
};
